import type { Action } from 'state/actions';
import { addKey, patchKey, removeKey } from 'state/utils/collection';

import * as actionTypes from './productModificationForm.actionTypes';
import type { ProductModificationFormState, ProductModificationStatus } from './productModificationForm.common';

export function productModificationFormReducer(
  state: ProductModificationFormState = {},
  action: Action,
): ProductModificationFormState {
  switch (action.type) {
    case actionTypes.PRODUCT_MODIFICATION_FORM_REQUESTED:
      if (state[action.tabId]) {
        return state;
      }

      return addKey(state, action.tabId, {
        status: 'INITIALIZED' as ProductModificationStatus,
      });
    case actionTypes.PRODUCT_MODIFICATION_RELOAD_FORM_REQUESTED:
      return patchKey(state, action.tabId, () => ({
        status: 'INITIALIZED' as ProductModificationStatus,
        hasConfirmedPublicOfferingDisclaimer: false,
        fightingBackJustification: undefined,
        fightingBackComment: '',
        productId: action.productId,
        requestId: undefined,
        errorMessages: undefined,
        astroStatus: undefined,
      }));
    case actionTypes.PRODUCT_MODIFICATION_FORM_RECEIVED:
      return patchKey(state, action.tabId, () => ({
        productId: action.productId,
        fightingBackJustification: '',
        fightingBackComment: '',
      }));
    case actionTypes.PRODUCT_MODIFICATION_FIGHTING_BACK_COMMENT_CHANGED:
      return patchKey(state, action.tabId, () => ({
        fightingBackComment: action.comment,
      }));
    case actionTypes.PRODUCT_MODIFICATION_PUBLIC_OFFERING_DISCLAIMER_CONFORMATION_CHANGED:
      return patchKey(state, action.tabId, () => {
        return {
          hasConfirmedPublicOfferingDisclaimer: action.hasConfirmed,
        };
      });
    case actionTypes.PRODUCT_MODIFICATION_FIGHTING_BACK_JUSTIFICATION_CHANGED:
      return patchKey(state, action.tabId, () => {
        return {
          fightingBackJustification: action.justification,
        };
      });
    case actionTypes.PRODUCT_MODIFICATION_APPLY_REQUESTED:
      return patchKey(state, action.tabId, () => ({
        status: 'PENDING' as ProductModificationStatus,
        requestId: action.requestId,
        technicalError: undefined,
        applyRequestStartedInMillis: action.startingTimeInMillis,
        applyRequestDurationInMillis: action.durationInMillis,
      }));
    case actionTypes.PRODUCT_MODIFICATION_APPLY_REQUEST_FAILED:
      return patchKey(state, action.tabId, () => ({
        status: 'FAILED' as ProductModificationStatus,
        requestId: undefined,
        technicalError: action.technicalError,
        applyRequestStartedInMillis: undefined,
        applyRequestDurationInMillis: undefined,
      }));
    case actionTypes.PRODUCT_MODIFICATION_RESULT_FAILED:
      return patchKey(state, action.tabId, () => ({
        status: 'FAILED' as ProductModificationStatus,
        requestId: undefined,
        technicalError: action.technicalError,
        applyRequestStartedInMillis: undefined,
        applyRequestDurationInMillis: undefined,
      }));
    case actionTypes.PRODUCT_MODIFICATION_RESULT_RECEIVED:
      return patchKey(state, action.tabId, () => ({
        status: 'SUCCESS' as ProductModificationStatus,
        errorMessages: action.productModificationResult.productModificationAck.errorMessages,
        astroStatus: action.productModificationResult.productModificationAck.status,
        technicalError: undefined,
        applyRequestStartedInMillis: undefined,
        applyRequestDurationInMillis: undefined,
      }));
    case 'WORKSPACE_TAB_REMOVED':
      return removeKey(state, action.id);
  }
  return state;
}
